import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, ref, watch } from 'vue';
import AddNotesArea from './AddNotesArea.vue';
import Modal from './Modal/Modal.vue';

type Props = {
  open: boolean;
  title: string;
  subtitle?: string;
  trip?: any;
  order?: any;
  container?: any;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AddNotesModal',
  props: {
    open: { type: Boolean },
    title: {},
    subtitle: {},
    trip: {},
    order: {},
    container: {}
  },
  emits: ["close", "addedNote", "archivedNotesUpdated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const isOpen = ref<boolean>(props.open);

const emit = __emit;

const localNotes = ref<any[]>([]);
const localArchivedNotes = ref<any[]>([]);

const hasEntity = computed(() => !!(props.trip || props.order || props.container));

const entityBindings = computed(() => {
  if (props.trip) return { trip: props.trip };
  if (props.order) return { order: props.order };
  if (props.container) return { container: props.container };
  return {};
});

function onClose() {
  emit('close');
}

function onAddedNote(notes: any[]) {
  const list = Array.isArray(notes) ? notes : [];
  localNotes.value = list;
  emit('addedNote', list);
}

function onArchivedNotesUpdated(archivedNotes: any[]) {
  const list = Array.isArray(archivedNotes) ? archivedNotes : [];
  localArchivedNotes.value = list;
  emit('archivedNotesUpdated', list);
}

/**
 * Same underlying Note type, different parent relations in the API:
 * Trip -> `tripNotes`
 * Order/ContainerLoad -> `notes`
 * (AddNotesArea picks the mutation from whichever of trip | order | container is passed)
 */
function readNotesFromProps(trip?: any, order?: any, container?: any): any[] {
  if (trip) {
    return Array.isArray(trip.tripNotes) ? trip.tripNotes : [];
  }
  const orderOrContainer = order ?? container;
  if (orderOrContainer) {
    return Array.isArray(orderOrContainer.notes) ? orderOrContainer.notes : [];
  }
  return [];
}

function readArchivedNotesFromProps(trip?: any, order?: any, container?: any): any[] {
  if (trip) {
    return Array.isArray(trip.archivedTripNotes) ? trip.archivedTripNotes : [];
  }
  const orderOrContainer = order ?? container;
  if (orderOrContainer) {
    return Array.isArray(orderOrContainer.archivedNotes) ? orderOrContainer.archivedNotes : [];
  }
  return [];
}

function syncFromEntity() {
  localNotes.value = readNotesFromProps(props.trip, props.order, props.container);
  localArchivedNotes.value = readArchivedNotesFromProps(props.trip, props.order, props.container);
}

watch(
  () => [props.trip, props.order, props.container],
  () => syncFromEntity(),
  { immediate: true, deep: true },
);

watch(
  () => props.open,
  (open) => { isOpen.value = open },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    isOpen: isOpen.value,
    "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    onClose: onClose
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.title), 1)
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.subtitle), 1)
    ]),
    content: _withCtx(() => [
      (!hasEntity.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "No order, trip or container found to show notes for"))
        : (_openBlock(), _createBlock(AddNotesArea, _mergeProps({
            key: 1,
            notes: localNotes.value,
            archivedNotes: localArchivedNotes.value
          }, entityBindings.value, {
            onAddedNote: onAddedNote,
            onArchivedNotesUpdated: onArchivedNotesUpdated
          }), null, 16, ["notes", "archivedNotes"]))
    ]),
    _: 1
  }, 8, ["isOpen"]))
}
}

})